import React, { useState } from 'react';
import {
  Container,
  Grid,
  makeStyles,
} from '@material-ui/core';
import Page from 'src/components/Page';
// import LatestProducts from './LatestProducts';
import Sales from './Sales';
import Imperatives from './Imperatives';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const Dashboard = () => {
  const classes = useStyles();

  const [chartData, setChartData] = useState({
    title: '',
    labels: [],
    data: []
  });

  React.useEffect(() => {
    console.log(chartData);
  }, [chartData]);

  return (
    <Page className={classes.root} title="Dashboard">
      <Container maxWidth={false}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Imperatives chartData={chartData} setChartData={setChartData} />
          </Grid>
          {/* <Grid item lg={1} md={0} xl={3} xs={12}>
            
          </Grid> */}
          <Grid item lg={6} md={12} xl={9} xs={12}>
            <Sales
              data={chartData.data}
              labels={chartData.labels}
              title={chartData.title}
              subtitle={chartData.ds}
            />
          </Grid>
          
          {/* <Grid item lg={12} md={12} xl={9} xs={12}>
            <LatestOrders />
          </Grid> */}
        </Grid>
      </Container>
    </Page>
  );
};

export default Dashboard;
